// import React from "react";

// const CustomRadio = ({
//   size = "md",
//   color = "primary", // primary, warning, success, danger, black, white
//   options = [],
//   selectedValue = "",
//   onChange,
// }) => {
//   const sizeClasses = {
//     sm: "w-3 h-3",
//     md: "w-4 h-4",
//     lg: "w-5 h-5",
//     xl: "w-6 h-6",
//   };

//   const fontSizeClasses = {
//     sm: "text-[12px]",
//     md: "text-[14px]",
//     lg: "text-[16px]",
//     xl: "text-[18px]",
//   };

//   // Define color classes
//   const colorClasses = {
//     primary: "peer-checked:bg-primary",
//     warning: " peer-checked:bg-warning",
//     success: " peer-checked:bg-success",
//     danger: " peer-checked:bg-danger",
//     black: " peer-checked:bg-black",
//     white: " peer-checked:bg-white",
//   };

//   const hoverColorClasses = {
//     primary: "group-hover:border-primary",
//     warning: "group-hover:border-warning",
//     success: "group-hover:border-success",
//     danger: "group-hover:border-danger",
//     black: "group-hover:border-black",
//     white: "group-hover:border-white",
//   };

//   return (
//     <div className="flex flex-wrap gap-4">
//       {options.map((option) => (
//         <label
//           key={option.value}
//           className={`group flex items-center cursor-pointer transition-all duration-200
//           ${fontSizeClasses[size]}`}
//         >
//           <input
//             type="radio"
//             name="custom-radio"
//             value={option.value}
//             checked={selectedValue === option.value}
//             onChange={() => onChange(option.value)}
//             className="hidden peer"
//           />
//           <div
//             className={`mr-2 flex justify-center items-center border-[1px] border-neutrals rounded-full
//             ${sizeClasses[size]} ${colorClasses[color]} ${hoverColorClasses[color]}`}
//           ></div>
//           {option.label}
//         </label>
//       ))}
//     </div>
//   );
// };

// export default CustomRadio;

// import React from "react";

// const CustomRadio = ({
//   size = "md",
//   color = "primary", // primary, warning, success, danger, black, white
//   options = [],
//   selectedValue = "",
//   onChange,
//   name = "custom-radio",
// }) => {
//   const sizeClasses = {
//     sm: "w-3 h-3",
//     md: "w-4 h-4",
//     lg: "w-5 h-5",
//     xl: "w-6 h-6",
//   };

//   const fontSizeClasses = {
//     sm: "text-[12px]",
//     md: "text-[14px]",
//     lg: "text-[16px]",
//     xl: "text-[18px]",
//   };

//   // Define color classes
//   const colorClasses = {
//     primary: "peer-checked:bg-primary peer-checked:border-primary",
//     warning: " peer-checked:bg-warning  peer-checked:border-warning",
//     success: " peer-checked:bg-success peer-checked:border-success",
//     danger: " peer-checked:bg-danger peer-checked:border-danger",
//     black: " peer-checked:bg-black peer-checked:border-black",
//     white: " peer-checked:bg-white peer-checked:border-white",
//   };

//   const hoverColorClasses = {
//     primary: "group-hover:border-primary",
//     warning: "group-hover:border-warning",
//     success: "group-hover:border-success",
//     danger: "group-hover:border-danger",
//     black: "group-hover:border-black",
//     white: "group-hover:border-white",
//   };

//   const handleChange = (e) => {
//     onChange(e);
//   };

//   return (
//     <div className="flex flex-wrap gap-4">
//       {options.map((option) => (
//         <label
//           key={option.value}
//           className={`group flex items-center cursor-pointer transition-all duration-200
//           ${fontSizeClasses[size]}`}
//         >
//           <input
//             type="radio"
//             // name="custom-radio"
//             name={name}
//             value={option.value}
//             checked={selectedValue === option.value}
//             onChange={onChange}
//             className="hidden peer"
//           />
//           <div
//             className={`mr-2 flex justify-center items-center border-[1px] border-neutrals rounded-full transition-all duration-700
//             ${sizeClasses[size]} ${colorClasses[color]} ${hoverColorClasses[color]} `}
//           >
//             <div className="w-1 h-1 bg-white rounded-full" />
//           </div>
//           {option.label}
//         </label>
//       ))}
//     </div>
//   );
// };

// export default CustomRadio;
import React from "react";

const CustomRadio = ({
  size = "md",
  color = "primary", // primary, warning, success, danger, black, white
  options = [],
  selectedValue = "",
  onChange,
  name = "custom-radio",
  disabled = false,
  list = false,
}) => {
  const sizeClasses = {
    sm: "w-3 h-3",
    md: "w-4 h-4",
    lg: "w-5 h-5",
    xl: "w-6 h-6",
  };

  const fontSizeClasses = {
    sm: "text-[12px]",
    md: "text-[14px]",
    lg: "text-[16px]",
    xl: "text-[18px]",
  };

  // Define color classes
  const colorClasses = {
    primary: "peer-checked:bg-primary peer-checked:border-primary",
    warning: "peer-checked:bg-warning peer-checked:border-warning",
    success: "peer-checked:bg-success peer-checked:border-success",
    danger: "peer-checked:bg-danger peer-checked:border-danger",
    black: "peer-checked:bg-black peer-checked:border-black",
    white: "peer-checked:bg-white peer-checked:border-white",
  };

  const hoverColorClasses = {
    primary: "group-hover:border-primary",
    warning: "group-hover:border-warning",
    success: "group-hover:border-success",
    danger: "group-hover:border-danger",
    black: "group-hover:border-black",
    white: "group-hover:border-white",
  };

  const disabledClasses =
    "border-neutrals-400 text-neutrals-400 cursor-not-allowed opacity-50";
  const disabledCheckedClasses = "bg-neutrals-400 border-neutrals-400";

  const handleChange = (e) => {
    if (!disabled) {
      onChange(e);
    }
  };

  return (
    <div className={`flex ${list ? "flex-col gap-2" : "flex-wrap gap-4"}`}>
      {options.map((option) => {
        const isChecked = String(selectedValue) === String(option.value);
        const appliedColorClass = disabled
          ? isChecked
            ? disabledCheckedClasses
            : disabledClasses
          : isChecked
          ? colorClasses[color]
          : hoverColorClasses[color];

        return (
          <label
            key={option.value}
            className={`group flex items-center transition-all duration-200 ${
              fontSizeClasses[size]
            } ${disabled ? disabledClasses : "cursor-pointer"}`}
          >
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={isChecked}
              onChange={handleChange}
              disabled={disabled}
              className="hidden peer"
            />
            <div
              className={`mr-2 flex justify-center items-center border-[1px] rounded-full transition-all duration-700 aspect-square ${sizeClasses[size]} ${appliedColorClass}`}
            >
              <div className="w-1 h-1 bg-white rounded-full" />
            </div>
            {option.label}
          </label>
        );
      })}
    </div>
  );
};

export default CustomRadio;
